import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { KeycloakService } from './keycloak.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(
    private keycloakService: KeycloakService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (this.keycloakService.getRealm() === 'master') {
      return this.router.parseUrl('/tenant-management/tenants');
    }
    const requiredAny = (route.data?.['requiredRolesAny'] as string[] | undefined) ?? [];
    const requiredAll = (route.data?.['requiredRolesAll'] as string[] | undefined) ?? [];

    if (requiredAny.length === 0 && requiredAll.length === 0) {
      return true;
    }

    const hasAny = requiredAny.length === 0 || this.keycloakService.hasAnyRole(requiredAny);
    const hasAll = requiredAll.length === 0 || this.keycloakService.hasAllRoles(requiredAll);

    if (hasAny && hasAll) {
      return true;
    }

    return this.router.parseUrl('/home');
  }
}
